// Libs
import _filter from 'lodash/filter'
import _find from 'lodash/find'
import _cloneDeep from 'lodash/cloneDeep'
import _map from 'lodash/map'
import _isEmpty from 'lodash/isEmpty'
import _startCase from 'lodash/startCase'
import { createSelector } from 'reselect'
import moment from 'moment'

// Types
import type {
  SoilJob,
} from 'hfty-model-soil-jobs/types'

import type {
  SoilJobFilters,
} from './../../types'

import {
  Season,
} from 'fc-model-seasons/types'

import type {
  Asset,
} from 'fc-model-assets/types'

// Utils
import emptyArrayOr from 'fc-utils/emptyArrayOr'

// Selectors
import jobs$ from './jobs'
import filters$ from './filters'
import { fields$ } from 'fc-assets'
import { seasons$ } from 'fc-seasons'

// Constants
import { DATE_FORMAT } from 'fc-components-datepicker/src/constants'

// Exports
export default createSelector(
  [jobs$, fields$, seasons$, filters$],
  function (
    jobs: { [number]: SoilJob },
    fields: Array<Asset>,
    seasons: Object<Season>,
    filters: SoilJobFilters): Array<SoilJob> {
    if (jobs) {
      let filteredJobs = _cloneDeep(jobs)
      const {status, startDate, endDate, assignTo, season} = filters

      // Filter by Season
      if (season) {
        filteredJobs = _filter(filteredJobs, (job) => {
          const fieldOfJob = _find(fields, {id: job.field})
          return fieldOfJob ? fieldOfJob.season === season : false
        })
      }

      // Filter by Assigned To
      if (assignTo) {
        filteredJobs = _filter(filteredJobs, (job) => {
          return job.assigned_to === assignTo
        })
      }

      // Filter by Status
      if (!_isEmpty(status)) {
        const parseStatus = _startCase(status)
        filteredJobs = _filter(filteredJobs, (job) => {
          return _startCase(job.status) === parseStatus
        })
      }

      // Filter by Created Date
      if (!_isEmpty(startDate) && !_isEmpty(endDate)) {
        const start = moment(startDate, DATE_FORMAT)
        const end = moment(endDate, DATE_FORMAT)
        filteredJobs = _filter(filteredJobs, (job) => {
          return moment.unix(job.created_date).isBetween(start, end, 'day', '[]')
        })
      }

      return emptyArrayOr(_map(filteredJobs))
    }
    return emptyArrayOr(jobs)
  }
)
